// import RepositoryFactory from "@/apis";
import { reject } from "lodash";
// const client = RepositoryFactory.client;
import client from "../../apis/client";

export default {
  uploadLogo({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await client.uploadLogo(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  uploadFavicon({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await client.uploadFavicon(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editClientDetails({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await client.editClientDetails(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
